import React from "react";
import Header from "components/Header/Header";
import Calculator from "components/Calculator/Calculator";
import OurService from "components/OurService/OurService";
import HowToStart from "components/HowToStartSection/HowToStartSection";
import WhyWeSection from "components/WhyWeSection/WhyWeSection";
import QASection from "components/QASection/QASection";
import GeneralQuestions from "components/GeneraQuestionsSection/GeneralQuestions";
import Footer from "components/FooterSection/Footer";
import ContactSection from "components/ContactSection/ContactSection";
import "./OTC.scss";

const OTC = () => {
  return (
    <div className="main-container">
      <Header />
      <Calculator />
      <OurService />
      <HowToStart />
      <WhyWeSection />
      <QASection />
      <GeneralQuestions />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default OTC;
